import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';

import { amplitudeLogout } from 'apps/auth/components/utils/AmplitudeUtils';
import { LOGIN } from 'apps/auth/constants/UrlConstants';
import { getFullEncodeApiUrl } from 'apps/auth/helpers/api';
import { logWarn, logError } from 'apps/auth/helpers/clientLogger';
import { addScript, removeScript } from 'apps/auth/helpers/DOM';
import { deletingWhiteSpaceInString } from 'apps/auth/helpers/utils';

import { ButtonContainer } from './styles';

const GooglePaySendButton = (props) => {
    let payButton = null;
    const googlePayRef = useRef(null);
    const GOOGLE_PAY_API = 'https://pay.google.com/gp/p/js/pay.js';
    let paymentsClient = null;

    useEffect(() => {
        addScript(GOOGLE_PAY_API, initPaymentsClient);
        return () => removeScript(GOOGLE_PAY_API);
    }, []);

    const baseRequest = {
        apiVersion: 2,
        apiVersionMinor: 0,
    };
    const tokenizationSpecification = {
        type: 'PAYMENT_GATEWAY',
        parameters: {
            gateway: props.google_gateway,
            gatewayMerchantId: props.google_checkout_merchant_id,
        },
    };
    const allowedCardNetworks = ['MASTERCARD', 'VISA'];
    const allowedCardAuthMethods = ['PAN_ONLY', 'CRYPTOGRAM_3DS'];
    const baseCardPaymentMethod = {
        type: 'CARD',
        parameters: {
            allowedAuthMethods: allowedCardAuthMethods,
            allowedCardNetworks: allowedCardNetworks,
        },
    };
    const cardPaymentMethod = Object.assign({ tokenizationSpecification: tokenizationSpecification }, baseCardPaymentMethod);

    const isReadyToPayRequest = Object.assign({}, baseRequest);
    isReadyToPayRequest.allowedPaymentMethods = [baseCardPaymentMethod];

    const paymentDataRequest = Object.assign({}, baseRequest);
    paymentDataRequest.allowedPaymentMethods = [cardPaymentMethod];
    paymentDataRequest.merchantInfo = {
        merchantName: props.paysend_google_display_name,
        merchantId: props.google_merchant_id,
    };
    paymentDataRequest.transactionInfo = {
        totalPriceStatus: 'FINAL',
        totalPrice: deletingWhiteSpaceInString(props.totalPrice),
        currencyCode: props.currencyCode,
        countryCode: props.countryCode,
    };

    const onGooglePaymentButtonClicked = () => {
        paymentsClient
            .loadPaymentData(paymentDataRequest)
            .then((paymentData) => {
                processPayment(paymentData);
            })
            .catch((err) => {
                logError(err);
            });
    };
    const processPayment = ({ paymentMethodData: { tokenizationData } }) => {
        fetch(
            getFullEncodeApiUrl(
                '/auth/send/google-pay/pay.action' +
                    '?token=' +
                    encodeURIComponent(tokenizationData.token) +
                    '&totalValue= ' +
                    paymentDataRequest.transactionInfo.totalPrice +
                    '&paymentId= ' +
                    props.paymentId,
            ),
            {
                method: 'POST',
                mode: 'cors',
                credentials: 'include',
                headers: {
                    Accept: 'application/json',
                },
            },
        )
            .then((response) => {
                if (response.status === 403) {
                    window.location.replace(LOGIN);
                    amplitudeLogout();
                    return;
                }
                return response.json();
            })
            .then((json) => {
                if (json.redirectTo) {
                    props.onClick();
                    window.location.replace(json.redirectTo);
                }
            })
            .catch((error) => {
                logWarn(error);
                return null;
            });
    };

    const initPaymentsClient = () => {
        if (paymentsClient === null) {
            paymentsClient = new google.payments.api.PaymentsClient({ environment: __isDev__ ? 'TEST' : 'PRODUCTION' });

            paymentsClient
                .isReadyToPay(isReadyToPayRequest)
                .then((res) => {
                    if (res.result) {
                        // add a Google Pay payment button
                        payButton = paymentsClient.createButton({ onClick: () => onGooglePaymentButtonClicked() });
                        googlePayRef.current.appendChild(payButton);
                    }
                })
                .catch((err) => {
                    logError(err);
                });
        }
    };

    return <ButtonContainer ref={googlePayRef} />;
};

const mapStateToProps = (state) => {
    const countryCode = state.extra.userCountry?.code?.toUpperCase() ?? state.extra.userCountry?.toUpperCase();
    return {
        totalPrice: state.extra.precheck.amountFrom,
        paymentId: state.extra.precheck.id,
        paysend_google_display_name: state.messages.jsMessages['paysend.google.display.name'],
        google_gateway: state.extra.google_gateway,
        google_merchant_id: state.extra.google_merchant_id,
        currencyCode: state.extra.precheck.amountFromCurrency,
        id: state.extra.id,
        google_checkout_merchant_id: state.extra.google_checkout_merchant_id,
        countryCode,
    };
};
export default connect(mapStateToProps)(GooglePaySendButton);
